import styled from "styled-components";
import bgPhone from "./../../resources/images/preLand/phone_bg.jpg";
import facesBg from "../../resources/images/icons/faces_bg.jpg";
import { SpoilerBlock } from "../design_components/Spoiler/styled";

const PreLandBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

PreLandBlock.Top = styled.div``;

PreLandBlock.Center = styled.div`
  background: #e0dff0;
  padding-top: 9px;
  padding-bottom: 40px;
`;

PreLandBlock.Center.Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 11px;
  border-bottom: 1px solid #c6c4df;
  margin-bottom: 21px;
`;

PreLandBlock.Block = styled.div`
  background: ${(props) => props.backgroundColor || 0};
  position: relative;
`;

PreLandBlock.Phone = styled.div`
  //height: 700px;
  background: url(${bgPhone});
  background-size: cover;
  padding-top: 40px;
  position: relative;
`;

PreLandBlock.Phone.Img = styled.div`
  position: relative;
`;

PreLandBlock.Phone.Gradient = styled.div`
  height: 95px;
  width: 100%;
  background: linear-gradient(180deg, rgba(5, 2, 55, 0) 0%, #050237 100.2%);
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
`;

PreLandBlock.Video = styled.div`
  width: 100%;
  height: 180px;
  background: url(${facesBg});
  background-size: cover;
  border-radius: 12px;
  position: relative;
  transition: 0.3s;
`;

PreLandBlock.Video.Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 0 15px;
`;

PreLandBlock.Video.Left = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  img {
    width: 66px;
    height: 66px;
  }
`;
PreLandBlock.Video.Right = styled.div`
  img {
    height: 180px;
  }
`;

PreLandBlock.Video.Player = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  video {
    height: 100%;
  }
`;

PreLandBlock.Spoilers = styled.div``;

export { PreLandBlock };
